import {
  useCanManageJobPostsBool,
  useCanViewCareerPreferencesBool,
  useCanViewCompensationProfilesBool
} from "@/hooks/useCapabilities";
import { canAccessCareerOverview } from "../_components/careerOverviewUtils";

export function useCanAccessCareerOverview(): boolean {
  const canViewCompensationProfiles = useCanViewCompensationProfilesBool();
  const canViewCareerPreferences = useCanViewCareerPreferencesBool();
  const canManageJobPosts = useCanManageJobPostsBool();

  return canAccessCareerOverview({
    canViewCareerPreferences,
    canViewCompensationProfiles,
    canManageJobPosts
  });
}
